<script>
export default {
    data() {
        return {
            year: 2020,
            month: null,
            years: [],
            months: [
                {
                    month: 1,
                    label: 'January'
                },
                {
                    month: 2,
                    label: 'February'
                },
                {
                    month: 3,
                    label: 'March'
                },
                {
                    month: 4,
                    label: 'April'
                },
                {
                    month: 5,
                    label: 'May'
                },
                {
                    month: 6,
                    label: 'June'
                },
                {
                    month: 7,
                    label: 'July'
                },
                {
                    month: 8,
                    label: 'August'
                },
                {
                    month: 9,
                    label: 'September'
                },
                {
                    month: 10,
                    label: 'October'
                },
                {
                    month: 11,
                    label: 'November'
                },
                {
                    month: 12,
                    label: 'December'
                }
            ]
        }
    },
    mounted() {
        var currentYear = moment().format('YYYY')
        this.year = currentYear;
        const until = 2000;
        while (currentYear > until) {
            this.years.push(parseInt(currentYear));
            currentYear--;
        }
    }
}
</script>
